import { render, staticRenderFns } from "./indicadores_mesesXfrecuencia.vue?vue&type=template&id=df521f40&"
import script from "./indicadores_mesesXfrecuencia.vue?vue&type=script&lang=ts&"
export * from "./indicadores_mesesXfrecuencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports